// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"f27ea2c2e22d65a21b7a","731":"c630501e759cb3f06436","843":"cff4afe7cadcd319a1bf","883":"f5d15e81247ce7569ae2"}[chunkId] + ".js";
};